export default __webpack_public_path__ + "static/media/centre-map.inline.f7a25174.svg";